<div class="row">  
  <span class="col-md-12 text-right boldlbl">Page 1 of 10</span>  
</div>
<div class="row p-4">
    <div class="col-md-12">
        <ng-container *ngIf= " urlExemptionId !== undefined && urlExemptionId == 19 ; else newNonProfit">
            <h3 class="text-center">New Vendor<br/> Requirements</h3>
        </ng-container>
        <ng-template #newNonProfit>
            <ng-container *ngIf=" urlExemptionId !== undefined && urlExemptionId >= 13  && urlExemptionId <= 16 ; else newBusReg">
                <h3 class="text-center">New Non-Profit<br/>Requirements</h3>
            </ng-container>
        </ng-template>
        <ng-template #newBusReg>
            <h3 class="text-center">{{eAppRegConstant.PageHeader}}<br/>Requirements</h3>
        </ng-template>
    </div>
</div>
<div class="card">
    <div class="card-body">
        <div class="row">
            <div class="col-md-12">
                <ol type="I">
                    <ng-container *ngIf= " urlExemptionId !== undefined && urlExemptionId == 19 ; else crtNewNonProfit">
                        <li class="boldlbl">CRITERIA FOR ONLINE REGISTRATION OF NEW VENDOR</li><br/>
                    </ng-container>
                    <ng-template #crtNewNonProfit>
                        <ng-container *ngIf=" urlExemptionId !== undefined && urlExemptionId >= 13  && urlExemptionId <= 16 ; else crtNewBusReg">
                            <li class="boldlbl">CRITERIA FOR ONLINE REGISTRATION OF NEW NON-PROFIT</li><br/>
                        </ng-container>
                    </ng-template>
                    <ng-template #crtNewBusReg>
                        <li class="boldlbl">CRITERIA FOR ONLINE REGISTRATION OF NEW BUSINESS</li><br/>
                    </ng-template>
                    
                    <p>The on-line business registration process requires that you meet <b>ALL</b> of the criteria listed below to be 
                        able to use the online process:</p>
                    <ol type="A">
                            <li>You are only opening <b>one</b> business location at this time.</li>
                            <li>You have never registered your business with the City of Los Angeles, Office of Finance.</li>
                            <li>Your business is physically located within the City limits or the business owner or his employees 
                                conducts business within the City limits.Click <a href="{{eAppRegConstant.AddressCityLimit}}" target="_blank">here</a> to find out if your address is within the City limits</li>
                            <li>You are NOT registering a cannabis business</li>
                            <li style="color:#FF0000"><b>ATTENTION:  Depending on the nature of your work, you may be required to pay 
                                registration fees.  If so, you must be able to complete an electronic payment as part of the registration 
                                process.  Please be prepared before you begin.</b></li>
                    </ol>
                    <br/>
                    <p><b>If you do not meet all of the criteria listed above</b> you may 
                        <a href="{{eAppRegConstant.ContatUs}}" target="_blank">contact us</a> or visit one of our 
                        <a href="{{eAppRegConstant.OfficeLocation}}" target="_blank">office locations</a> to register 
                            your business. &nbsp;You may also visit our <a href="{{eAppRegConstant.FormsLibrary}}" target="_blank">Forms Library</a> and download the "Business Tax Registration Certificate Application (New Businesses)" form.  Once complete, you can email it as an attachment to <a href="mailto:Finance.CustomerService@lacity.org" target="_blank">Finance.CustomerService@lacity.org</a>. &nbsp;This allows you 
                            to request a business tax registration but you will not immediately get a temporary certificate like you will with this application.
                    </p>
                    <br />
                    <p><b>For cannabis related businesses</b>, visit the Department of Cannabis Regulation (DCR) website <a href="https://cannabis.lacity.org/"  target="_blank">https://cannabis.lacity.org/</a> for licensing information prior to registering your cannabis business with the Office of Finance. Your registration will not be accepted without going through DCR's licensing process.</p>
                    <br />
                    <li class="boldlbl">INFORMATION YOU WILL NEED TO PROVIDE TO REGISTER A NEW BUSINESS ONLINE</li><br/>
                    
                    <p>Through this on-line registration process you will be asked to provide information about your 
                        business.  Please have the following information at hand for your registration.</p>
                        
                    <ol type="A">
                        <li>Social Security Number (if business is a Sole Proprietorship) or Federal Employment 
                            Identification Number (if business is either Partnership, Corporation, Limited Liability Company 
                            or Trusts)</li>
                        <li>Description of your Business activities</li>
                        <li>Legal Business Name</li>
                            
                        <ol type="1">
                            
                            <li>Business Name - Doing Business As (optional)</li>
                                
                        </ol>
                            
                        <li>Business Start Date</li>
                        <li>Business Type (such as Sole Proprietorship, Partnership, Corporation, etc.)</li>
                        <li>Primary Business Address</li>
                            
                        <ol type="1">
                            
                            <li>Mailing Address - if different from your primary business address</li>
                                
                        </ol>
                            
                        <li>Business Contact Information (such as your CPA, Controller, etc)</li>
                        <li>Other information you may need to submit.</li>

						<ol type="1">

							<li>Sales Tax Number</li>
							<li>Business/Professional Activity Code</li>
							<li>Prior Year(s) Business Gross Receipts - if your business
								start date is prior to the current year, you will be required to
								provide your business's gross receipts from the prior years.</li>

						</ol>
					</ol>
                        
                    <br /><br />
                    
                    <li class="boldlbl">PERMITS YOU MAY NEED TO OBTAIN FOR YOUR NEW BUSINESS</li>
                    
                    <br />					
                
                    <ol type="A">
                        
                        <li>Police Alarm Permit</li><br/>
                            
                        <p>A police alarm permit is required if you have an alarm system at your business location within the 
                                City limits. You will be directed to the Police Alarm Permit Application at the end of this process 
                                if one is present.</p>
    
                        <li>Tobacco Retailers Permit</li><br/>
                            
                        <p>A tobacco retailers permit is required if you sell tobacco, tobacco products or tobacco 
                            paraphernalia within City limits. You will need to visit one of our offices to set up and pay for 
                            the tobacco permit</p>
                            
                        <li>Police Non Alarm Permits and Fire Permits</li><br/>
                            
                        <p>There may be Police Non Alarm Permits or Fire permits required for the business activity you 
                            are engaged in.  There will be some questions asked later that will help you to determine if you 
                            will need to come into one of our offices to complete this process.</p>
                            
                    </ol>
                
                    <br /><br />
                    
                    <li class="boldlbl">STEPS TO COMPLETE A NEW BUSINESS ONLINE REGISTRATION</li>
                        
                    <br />	
                    
                    <ol type="A">
                        
                        <li>New Business Registration Application</li><br/>
                            
                        <p>You will be asked to provide the following information needed to register a new business: Legal 
                            Business Name, Business Name/Doing Business As (optional), Business Start Date, Business Type, Primary Business Address, Mailing Address (if different from 
                            primary business address), Business Contact Information, Sales Tax Number (if you have one 
                            please provide it) and Business/Professional Activity Code.</p>
    
                        <li>New Business Registration Confirmation</li><br/>
                            
                        <p>You will be asked to confirm your answers to the eligibility questionnaire and new business 
                            registration application.</p>
                            
                        <li>New Business Registration Application Confirmation email</li><br/>
                            
                        <p>A new business registration application confirmation email will be issued acknowledging the 
                            submittal of your application and will give you additional step if you have any to complete. </p>
    
                        <li>Temporary Tax Registration Certificate</li><br/>
                            
                        <p>A temporary business tax registration certificate will be issued for you to print and display at your 
                            place of business.  A permanent certificate will be sent via mail and should arrive within 4 weeks 
                            from completing your on-line registration. Please remove the temporary certificate and replace it 
                            with the permanent certificate.</p>
                            
                    </ol>
                                                    
                </ol>
                    
                <br />
            </div>
        </div>
        <div class="row text-center">
            <div class="col-md-12">
                <button class="btn btn-primary" (click)="print_page()" >Print</button>&nbsp;&nbsp;
                <button class="btn btn-primary" [routerLink]="['/eappreg_fasttrack']" >&nbsp;&nbsp;Proceed&nbsp;&nbsp;</button>
            </div>
        </div>
    </div>
</div>
<div>
    <br>
</div>
